import * as yup from "yup";

import { DocumentationType } from "src/clients/flow-api";
import {
  DocumentationEntry,
  OnePasswordLinkEntry,
  PromoteFlowVersionFormData,
  ProviderType,
} from "src/flowContainer/ManifestPromotion/types";

const DOCUMENTATION_TYPES: DocumentationType[] = [
  DocumentationType.PRODUCT_SPEC,
  DocumentationType.API_REFERENCE,
  DocumentationType.INTEGRATION_GUIDE,
  DocumentationType.OTHER,
];

const onePasswordLinkSchema: yup.ObjectSchema<OnePasswordLinkEntry> =
  yup.object({
    url: yup
      .string()
      .required("1Password link is required")
      .test(
        "is-1password-url",
        "Must be a valid 1Password link",
        (value) => !value || value.includes(".1password."),
      ),
  });

const documentationSchema: yup.ObjectSchema<DocumentationEntry> = yup.object({
  url: yup
    .string()
    .required("Documentation URL is required")
    .url("Must be a valid URL"),
  type: yup
    .string()
    .oneOf(DOCUMENTATION_TYPES)
    .required(
      "Documentation type is required",
    ) as yup.Schema<DocumentationType>,
});

export const promoteFlowVersionSchema: yup.ObjectSchema<PromoteFlowVersionFormData> =
  yup.object({
    providerType: yup
      .string()
      .oneOf(["new", "existing"] as const)
      .required("Provider type is required") as yup.Schema<ProviderType>,
    existingProviderName: yup.string().when("providerType", {
      is: "existing",
      then: (schema) => schema.required("Please select an existing provider"),
      otherwise: (schema) => schema.optional(),
    }),
    newProviderDescription: yup.string().optional(),
    onePasswordLinks: yup.array().of(onePasswordLinkSchema).optional(),
    documentations: yup.array().of(documentationSchema).optional(),
    errorHandling: yup.string().optional(),
    comments: yup.string().optional(),
  });
